import React from "react";
import { useLanguage } from "../context/LanguageContext";
import LegalPage from "../components/LegalPage";

const Privacy = () => {
  const { t } = useLanguage();
  return <LegalPage data={t.privacyPage} />;
};

export default Privacy;
